import { render, staticRenderFns } from "./DialogListArticleInContener.vue?vue&type=template&id=4396df97"
import script from "./DialogListArticleInContener.vue?vue&type=script&lang=js"
export * from "./DialogListArticleInContener.vue?vue&type=script&lang=js"
import style0 from "./DialogListArticleInContener.vue?vue&type=style&index=0&id=4396df97&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports